import React, { useEffect, useState } from "react";

import moment from "moment";

import ExistingPlans from "./ExistingPlans";
import NutritionPlanChart from "./NutritionPlanChart";
import NutritionPlanCalendar from "./NutritionPlanCalendar";

const todayUtc = Number(moment().format("YYYYMMDD"));

const NutritionPlans = ({ nutritionPlans, activeUser, dailyStats }) => {
  const { units } = activeUser;
  const startingCalendarDay = activeUser.startingCalendarDay || 0;

  const [activePlan, setActivePlan] = useState({});

  useEffect(() => {
    const activeNutritionPlan = nutritionPlans.find(
      (plan) => plan.utcStartDate <= todayUtc && plan.utcEndDate >= todayUtc
    );

    const activePlanStats = activeNutritionPlan
      ? {
          id: activeNutritionPlan._id,
          startDate: activeNutritionPlan.utcStartDate,
          endDate: activeNutritionPlan.utcEndDate,
          nutrients: {
            proteins: activeNutritionPlan.proteins || 0,
            carbs: activeNutritionPlan.carbs || 0,
            fats: activeNutritionPlan.fats || 0,
          },
          restDay: activeNutritionPlan.restDay
            ? { ...activeNutritionPlan.restDay }
            : null,
          notes: activeNutritionPlan.notes ? activeNutritionPlan.notes : null,
        }
      : {};

    setActivePlan(activePlanStats);
  }, [nutritionPlans]);

  const handleChangeActivePlan = (id) => {
    const planData = nutritionPlans.find((plan) => plan._id === id);

    setActivePlan({
      id: planData._id,
      startDate: planData.utcStartDate,
      endDate: planData.utcEndDate,
      nutrients: {
        proteins: planData.proteins || 0,
        carbs: planData.carbs || 0,
        fats: planData.fats || 0,
      },
      restDay: planData.restDay ? { ...planData.restDay } : null,
      notes: planData.notes ? planData.notes : null,
    });
  };

  return (
    <div>
      <div className="active-plan-summary">
        <ExistingPlans
          nutritionPlans={nutritionPlans}
          activePlanId={activePlan.id}
          handleChangeActivePlan={handleChangeActivePlan}
        />

        {activePlan.id ? (
          <NutritionPlanChart planStats={activePlan} />
        ) : (
          <div className="nutrition-plan-summary empty-state">
            <span className="nutrition-plan-summary-title">Plan</span>
            <p className="p4">No data to show</p>
          </div>
        )}
      </div>

      <NutritionPlanCalendar
        startingCalendarDay={startingCalendarDay}
        nutritionPlans={nutritionPlans}
        stats={dailyStats}
        units={units}
      />
    </div>
  );
};

export default NutritionPlans;
